type FalsyValue = undefined | null | false | '' | 0;
type FilterFalsy = <T>(x: T | FalsyValue) => x is T;

export const filterFalsy = (<Type = unknown>(
  input: Type | FalsyValue,
): boolean =>
  !(
    input === undefined ||
    input === false ||
    input === null ||
    input === '' ||
    input === 0
  )) as FilterFalsy;

const excludeFalsy = <T>(arr: readonly (T | FalsyValue)[] | FalsyValue) =>
  (arr || []).filter(filterFalsy<T>) as T[];

export default excludeFalsy;
